import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NavMandateContext, NavModule, NavStep } from './navigation-bar.types';

/**
 * REV-21353 — Pure View: Mandats-Navigation (Module + Jahresabschluss-Unterschritte).
 *
 * Reines Präsentations-Bauteil: keine Business-Logik, kein Store, keine API-Calls; Daten rein
 * über @Input, Ereignisse raus über @Output. Controlled — Klicks emittieren nur, sie mutieren
 * nie den internen State (collapsed/expandedModuleId/active* kommen als Input).
 */
@Component({
    selector: 'ham-navigation-bar',
    templateUrl: './navigation-bar.component.html',
    styleUrls: ['./navigation-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HamNavigationBarComponent {
    @Input() mandate!: NavMandateContext;
    @Input() modules: NavModule[] = [];
    @Input() activeModuleId: string | null = null;
    @Input() activeStepId: string | null = null;
    @Input() expandedModuleId: string | null = null;
    @Input() collapsed = false;
    @Input() loading = false;
    @Input() error = false;

    @Output() moduleSelect = new EventEmitter<string>();
    @Output() stepSelect = new EventEmitter<{ moduleId: string; stepId: string }>();
    @Output() collapsedToggle = new EventEmitter<boolean>();
    /** The module id whose `action` button was clicked. */
    @Output() moduleAction = new EventEmitter<string>();

    get isEmpty(): boolean {
        return this.modules.length === 0;
    }

    /** Aufgeklapptes Modul; Default = aktives Modul. */
    get expandedId(): string | null {
        return this.expandedModuleId ?? this.activeModuleId;
    }

    isModuleExpanded(module: NavModule): boolean {
        return !!module.steps?.length && module.id === this.expandedId;
    }

    trackByModuleId(_index: number, module: NavModule): string {
        return module.id;
    }

    trackByStepId(_index: number, step: NavStep): string {
        return step.id;
    }

    onModuleClick(id: string): void {
        this.moduleSelect.emit(id);
    }

    /** A locked step stays where it is: no event, nothing for the host to refuse. */
    onStepClick(moduleId: string, step: NavStep): void {
        if (step.locked) {
            return;
        }
        this.stepSelect.emit({ moduleId, stepId: step.id });
    }

    onToggleCollapse(): void {
        this.collapsedToggle.emit(!this.collapsed);
    }
}
